import { NtapGlobalConstants, View, ViewProviderDirective } from '@ntap/core';
import { Observable, of } from 'rxjs';

export class NoopViewProvider extends ViewProviderDirective<View> {
  private itemType: string;

  override get view$() {
    return of({
      [NtapGlobalConstants.ATTR_$mainType]: this.itemType
    }) as unknown as Observable<View>;
  }

  setItemType(type: string) {
    this.itemType = type;
  }

  refresh() {}
}
